import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-304034d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_3 = { class: "card mb-5 mb-xl-8" }
const _hoisted_4 = { class: "card-body pt-15" }
const _hoisted_5 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_6 = { class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Proveedor", -1))
const _hoisted_8 = { class: "fs-5 text-muted mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Rut Proveedor", -1))
const _hoisted_10 = { class: "fs-5 text-muted mb-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Teléfono Contacto", -1))
const _hoisted_12 = { class: "fs-5 text-muted mb-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Email contacto", -1))
const _hoisted_14 = { class: "fs-5 fw-bold text-muted mb-2" }
const _hoisted_15 = { class: "d-flex flex-wrap flex-center" }
const _hoisted_16 = { class: "fs-4 fw-bolder text-gray-700" }
const _hoisted_17 = { class: "w-75px" }
const _hoisted_18 = { class: "svg-icon svg-icon-3 svg-icon-success" }
const _hoisted_19 = { class: "fw-bold text-muted" }
const _hoisted_20 = { class: "d-flex flex-stack fs-4 py-3" }
const _hoisted_21 = {
  class: "fw-bolder rotate collapsible",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_22 = { class: "ms-2 rotate-180" }
const _hoisted_23 = { class: "svg-icon svg-icon-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1))
const _hoisted_25 = {
  id: "kt_customer_view_details",
  class: "collapse show"
}
const _hoisted_26 = { class: "py-5 fs-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Fecha de la Solicitud", -1))
const _hoisted_28 = { class: "text-gray-600" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Estado Actual", -1))
const _hoisted_30 = { class: "text-gray-600" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mt-5" }, "Rut del solicitante", -1))
const _hoisted_32 = { class: "text-gray-600" }
const _hoisted_33 = {
  href: "#",
  class: "text-gray-600 text-hover-primary"
}
const _hoisted_34 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_35 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link text-active-primary pb-4 active",
    "data-bs-toggle": "tab"
  }, "Movimientos del Proveedor Asociado")
], -1))
const _hoisted_37 = { class: "nav-item ms-auto" }
const _hoisted_38 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_39 = {
  class: "tab-pane fade show active",
  id: "kt_customer_view_overview_tab",
  role: "tabpanel"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Agent Picker", -1))
const _hoisted_41 = { class: "p-multiselect-representative-option" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png",
  width: "30",
  style: {"vertical-align":"middle"}
}, null, -1))
const _hoisted_43 = { class: "image-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_avatar = _resolveComponent("avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_NewCardModal = _resolveComponent("NewCardModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toast),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_avatar, {
                size: "80",
                fullname: _ctx.currentSolicitud.contactoNombreCompleto,
                color: "#005E8A"
              }, null, 8, ["fullname"]),
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.currentSolicitud.contactoNombreCompleto), 1),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentProveedor.nombreProveedor), 1),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.currentSolicitud.rutProveedor), 1),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentSolicitud.contactoTelefono), 1),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.currentSolicitud.contactoEmail), 1),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters.allDashboard, (estado) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: estado.id,
                    class: "border border-gray-300 border-dashed rounded py-3 px-3 mb-3"
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatCurrency(estado.monto)), 1),
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(estado.nombre), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(" Detalle de la solicitud "),
                _createElementVNode("span", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
                  ])
                ])
              ])
            ]),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDate(_ctx.currentSolicitud.fechaSolicitud)), 1),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.estadoActual(_ctx.currentSolicitud.activado)), 1),
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("a", _hoisted_33, _toDisplayString(_ctx.currentSolicitud.contactoRut), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("ul", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("li", _hoisted_37, [
            _createVNode(_component_Button, {
              label: "Aprobar",
              class: "btn btn-melon mr-5",
              icon: "pi pi-check",
              iconPos: "left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.aprobar($event)))
            }),
            _createVNode(_component_Button, {
              label: " Rechazar",
              class: "btn btn-melon-secundario",
              icon: "pi pi-times",
              iconPos: "left",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rechazar($event)))
            }),
            _createVNode(_component_ConfirmPopup)
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_DataTable, {
              value: _ctx.store.getters.allFacturas,
              paginator: false,
              rows: 10,
              showGridlines: "",
              dataKey: "id",
              rowHover: true,
              selection: _ctx.selectedCustomers,
              "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCustomers) = $event)),
              filters: _ctx.filters1,
              "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters1) = $event)),
              loading: _ctx.loading,
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              rowsPerPageOptions: [10, 25, 50],
              currentPageReportTemplate: "Mostrando {first} a {last} de {totalRecords} registros",
              globalFilterFields: [
              'numeroFactura',
              'nombreEmpresa',
              'detalleEstado',
            ],
              responsiveLayout: "scroll"
            }, {
              empty: _withCtx(() => [
                _createTextVNode(" No existen documentos. ")
              ]),
              loading: _withCtx(() => [
                _createTextVNode(" Cargando sus documentos. Por favor espere. ")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "numeroFactura",
                  header: "Nº Factura",
                  style: {"min-width":"9rem"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.numeroFactura), 1)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _createVNode(_component_InputText, {
                      type: "text",
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      class: "p-column-filter",
                      placeholder: "Search by name"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "nombreEmpresa",
                  header: "Empresa",
                  filterMatchMode: "contains",
                  style: {"min-width":"14rem"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(data.nombreEmpresa), 1)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _createVNode(_component_InputText, {
                      type: "text",
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      class: "p-column-filter",
                      placeholder: "Search by country"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "detalleEstado",
                  header: "Estado",
                  filterField: "detalleEstado",
                  sortField: "detalleEstado",
                  showFilterMatchModes: false,
                  filterMenuStyle: { width: '14rem' },
                  style: {"min-width":"14rem"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["image-text", 'customer-badge status-' + data.estado])
                    }, _toDisplayString(data.detalleEstado), 3)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _hoisted_40,
                    _createVNode(_component_MultiSelect, {
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      options: _ctx.representatives,
                      optionLabel: "name",
                      placeholder: "Any",
                      class: "p-column-filter"
                    }, {
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("span", _hoisted_43, _toDisplayString(slotProps.option.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "monto",
                  header: "Monto",
                  dataType: "numeric",
                  style: {"min-width":"8rem"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.formatCurrency(data.monto)), 1)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _createVNode(_component_InputNumber, {
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      mode: "currency",
                      currency: "USD",
                      locale: "en-US"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "fechaEmision",
                  header: "F. Emisión",
                  dataType: "date",
                  style: {"min-width":"8rem"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaEmision)), 1)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _createVNode(_component_Calendar, {
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      dateFormat: "mm/dd/yy",
                      placeholder: "mm/dd/yyyy"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "fechaRecepcion",
                  header: "F. Recepción",
                  dataType: "date",
                  style: {"min-width":"8rem"}
                }, {
                  body: _withCtx(({ data }) => [
                    _createTextVNode(_toDisplayString(_ctx.formatDate(data.fechaRecepcion)), 1)
                  ]),
                  filter: _withCtx(({ filterModel }) => [
                    _createVNode(_component_Calendar, {
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      dateFormat: "mm/dd/yy",
                      placeholder: "mm/dd/yyyy"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "selection", "filters", "loading"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_NewCardModal)
  ], 64))
}